import http from "./Endpoint";
import { appConstant } from "config/constant";

class CartService {

  applyCoupon(data) {
    return http().post("/cart/applyCoupon", data);
  }

  getCartOptions(data) {
    return http().post("/cart/getCartOptions", data);
  }

  updateCartOptions(data) {
    return http().post("/cart/updateCartOptions", data);
  }

  /**
   * Update cart item
   * @param {*} data 
   * {
   *   user_id: user.id,
   *   id: lineItem.id,
   *   quantity: qnty
   *   "options": {}
   * }
   * @returns 
   */
  update(data) {
    return http().post("/cart/update", data);
  }

  removeItem(data) {
    return http().post("/cart/removeItem", data);
  }

  emptyCart(data) {
    return http().post("/cart/emptyCart", data);
  }

  getCCInfo(data) {
    return http().post("/cart/getCCInfo", data);
  }

  /**
   * Add a preorder to cart
   * @param data -  
   * {
   *   "customer_id": 12,
   *   "user_id": 10615,
   *   "product_id": null,
   *   "preorder_id": null,
   *   "quantity": 100
   * }
   */
  addPreorder2Cart(data) {
    return http().post("/cart/addPreorder2Cart", data);
  }

  /**
   * 
   * @param {*} data - {
   *  "filter": {
   *    "user_id": 1
   *    "return": [
   *       "product"
   *     ]
   *   }
   * }
   * @returns 
   */
  query(data) {
    return http().post("/cart/query", data);
  }

  /**
   * Get cart shipping cost
   * @param data = {
   *   "user_id": 214000,
   *   "delivery_method_id": 13,
   *   "address_id": 1112948,
   *   "direct_source": true
   * } 
   * @returns {
   *  
   * }
   */
  getShippingCost(data) {
    return http().post("/cart/getShippingCost", data);
  }
}

export default new CartService();